
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findFactura"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFactura"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cobranza"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deuda"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"monto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoNoFacturable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoFacturable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaComprobante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaVencimiento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipoComprobante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"letra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"puntoVenta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroComprobante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuitCliente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniCliente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"razonSocialCliente"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descripcionVenta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtotalGravadoIVA105"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtotalGravadoIVA21"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtotalGravadoIVA27"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalNetoNoGravado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percepcionIVA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jurisdiccionIIBB"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalComprobante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuentaIngreso"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreCuenta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medioCobro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"centroCosto1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"centroCosto2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periodoDesde"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periodoHasta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cbu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cae"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nroFactura"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"netoGravado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"importeIva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colppyRequest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colppyResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idFacturaColppy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idClienteColppy"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1086}};
    doc.loc.source = {"body":"query findFactura($id:ID!){\n    findFactura(id:$id){\n        id\n        cobranza{\n            id\n            dniDeudor\n            nombreDeudor\n        }\n        deuda{\n            id\n            dniDeudor\n            nombreDeudor\n        }\n        monto\n        montoNoFacturable\n        montoFacturable\n        estado\n        lote\n        fechaComprobante\n        fechaVencimiento\n        tipoComprobante\n        letra\n        puntoVenta\n        numeroComprobante\n        cuitCliente\n        dniCliente\n        razonSocialCliente\n        descripcionVenta\n        subtotalGravadoIVA105\n        subtotalGravadoIVA21\n        subtotalGravadoIVA27\n        totalNetoNoGravado\n        percepcionIVA\n        jurisdiccionIIBB\n        totalComprobante\n        cuentaIngreso\n        nombreCuenta\n        medioCobro\n        centroCosto1\n        centroCosto2\n        periodoDesde\n        periodoHasta\n        cbu\n        cae\n        nroFactura\n        tipo\n        netoGravado\n        importeIva\n        colppyRequest\n        colppyResponse\n        idFacturaColppy\n        idClienteColppy\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["findFactura"] = oneQuery(doc, "findFactura");
        
